import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import IAsync from 'types/IAsync';
import IUser from 'types/IUser';

function setProfileAsync(profileAsync: IAsync<IUser>) {
  store.setState({ profileAsync });
}

export default function fetchProfile() {
  const async = store.getState().profileAsync;

  switch (async.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setProfileAsync({ status: 'PENDING' });
      break;
    case 'SUCCESS':
      // Only fetch this once
      return;
  }

  api
    .get(`profile`)
    .json()
    .then(
      (data) => {
        setProfileAsync({ status: 'SUCCESS', data: data as IUser });
      },
      (error) => {
        Sentry.captureException(error);
        setProfileAsync({ status: 'ERROR' });
      },
    );
}
